import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  AbstractControl,
  ValidationErrors,
} from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { CommentsService } from '../services/comments.service';
import { ToastService } from '@/app/shared/services/toastr.service';
import { UserComments } from '@/app/shared/types/userComments.type';
import { AuthHelper } from '../helpers/auth.helper';

@Component({
  selector: 'app-comments',
  templateUrl: './comments.component.html',
  styleUrl: './comments.component.css',
})
export class CommentsFeedbackComponent implements OnInit {
  form!: FormGroup;
  token?: string;
  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly formBuilder: FormBuilder,
    private readonly commentsService: CommentsService,
    private readonly toastService: ToastService,
    private readonly authHelper: AuthHelper
  ) {
    this.initForm();
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      if (params['token']) {
        this.token = params['token'];
        if (!this.userLogged)
          this.authHelper.saveSession({
            expirationDate: new Date(),
            userToken: this.token as any,
            user: null as any,
            expiresIn: 0,
          });
      } else {
        this.token = this.authHelper.getUserToken()?.userToken;
      }
    });
  }

  get userLogged(): boolean {
    return this.authHelper.isUserLogged();
  }

  private starsRangeValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (value < 1 || value > 5) {
      return { starsRange: true };
    }
    return null;
  }

  private initForm(): void {
    this.form = this.formBuilder.group({
      comment: [''],
      stars: [null, [Validators.required, this.starsRangeValidator]],
    });
  }

  public onSubmit(): void {
    if (this.form.valid) {
      const comment: UserComments = {
        comment: this.form.get('comment')?.value || '',
        stars: this.form.get('stars')?.value,
      };

      this.commentsService.createComment(comment).subscribe({
        next: () => {
          this.toastService.showSuccess('Thank you for your feedback!');
          const url = this.userLogged ? '/control-panel/patients' : '/';
          this.router.navigate([url]);
        },
        error: error => {
          this.toastService.showError('Error submitting feedback. Please try again.');
          console.error('Error submitting feedback:', error);
        },
      });
    }
  }

  onCancel(): void {
    this.router.navigate(['/']);
  }
}
